export const clamp01 = (value: number): number => Math.min(1, Math.max(0, value));

export const lerp = (from: number, to: number, progress: number): number => (progress === 1 ? to : from + (to - from) * progress);

export const roundTo = (value: number, digits: number): number => {
    const rounded = Number(value.toFixed(digits));

    return Object.is(rounded, -0) ? 0 : rounded;
};
export const clamp01 = (value: number): number => Math.min(1, Math.max(0, value));

export const lerp = (from: number, to: number, progress: number): number => (progress === 1 ? to : from + (to - from) * progress);

export const roundTo = (value: number, digits: number): number => {
    const rounded = Number(value.toFixed(digits));

    return Object.is(rounded, -0) ? 0 : rounded;
};
